import Vue from "vue";
import Vuetify from "vuetify/lib";
// Self-hosted icon fonts and typography — pinned npm packages instead of the
// former unpinned CDN links, so icons can never fail or version-shift
// independently of the build.
import "@mdi/font/css/materialdesignicons.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";
import ar from "vuetify/lib/locale/ar";
import en from "vuetify/lib/locale/en";
import { LOCALE_STORAGE_KEY, normalizeLocale } from "../i18n";

Vue.use(Vuetify);

/*
 * Vuetify keeps its own translation table, separate from vue-i18n. The
 * data-table footer ("Rows per page:"), the empty state ("No data available"),
 * the loading row, the pagination aria-labels and the calendar's day names all
 * come from here — not from src/locales — so without this they stay English no
 * matter what $t() does.
 *
 * Read straight from localStorage rather than via language-service, because that
 * module imports this one; it keeps `lang.current` in step on a change.
 */
function bootLocale() {
  try {
    if (typeof localStorage === "undefined") return "en";
    return normalizeLocale(localStorage.getItem(LOCALE_STORAGE_KEY));
  } catch (e) {
    return "en";
  }
}

const theme = {
  primary: "#018294",
  secondary: "#01B3AC",
  background: "#FFFFFF",
  light: "#FFFFFF",
  dark: "#000000",
  bg: "#F8FBFB",
};

const injectThemeVariables = () => {
  const root = document.documentElement;
  Object.keys(theme).forEach(key => {
    root.style.setProperty(`--theme-${key}`, theme[key]);
  });
};

Vue.nextTick(() => {
  injectThemeVariables();
});

export default new Vuetify({
  lang: {
    locales: { en, ar },
    current: bootLocale(),
  },
  rtl: bootLocale() === "ar",
  theme: {
    themes: {
      light: theme,
    },
  },
});

export { theme, injectThemeVariables };
